'use client';

import { type PropsWithChildren } from 'react';
import { DeviceHeaderContext } from './DeviceHeaderContext';
import type { Device } from '../../utils/types';

export const DeviceHeaderProvider = ({
  children,
  headersPromise,
}: PropsWithChildren<{ headersPromise: Promise<Device | null> }>) => (
  <DeviceHeaderContext.Provider value={headersPromise}>{children}</DeviceHeaderContext.Provider>
);
